<template>
    <v-dialog v-model="dialog" persistent width="400">
        <v-card>
            <v-toolbar class="text-h5 white--text" color="primary">
                <v-icon class="mr-2" color="white">create_new_folder</v-icon>
                Crea Cartella
            </v-toolbar>
            <v-card-text class="my-5">
                <v-row class="align-center">
                    <v-text-field label="Nome Cartella" v-model="nomeCartella" autofocus />
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="chiudiDialog()">
                    ANNULLA
                </v-btn>
                <v-btn color="primary" text @click="creaCartella(nomeCartella)">
                    CONFERMA
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { crea_cartella } from "@/api/api.dati.js";

export default {
    props: {
        dialog: { type: Boolean, default: false },
        selectedRow: { type: Object, default: null },
        pathIndietro: { type: String, default: null },
    },

    data: () => ({
        nomeCartella: "",
        successDir: false,
        errorDir: false,
    }),

    methods: {
        chiudiDialog(successDir, errorDir) {
            this.$emit("chiudiDialog", successDir, errorDir);
            this.successDir = false; this.errorDir = false;
        },

        async creaCartella(nome) {
            let par = ""; let path = "";
            if (nome) {
                let data = {
                    nome: nome,
                    path: ""
                }

                if (this.pathIndietro != "") {
                    if (this.selectedRow != null || this.selectedRow != undefined) path = this.controlloPath(this.selectedRow.path);
                    else path = this.controlloPath(this.pathIndietro);
                    par = "?path=" + encodeURIComponent(path);
                    data.path = path;
                }
                else if (this.selectedRow != null || this.selectedRow != undefined) {
                    par = "?path=" + encodeURIComponent(this.selectedRow.path);
                }

                let res = await crea_cartella(data, par);
                if (res.data == "OK") {
                    this.successDir = true;
                    this.nomeCartella = ""
                    this.getResources(false);
                } else this.errorDir = true;//this.$toast.alert("Errore nella creazione della cartella. " + res.data);
            }

            this.chiudiDialog(this.successDir, this.errorDir);//chiudo dialog
        },

        controlloPath(path) {
            let url = path.split("/");
            if (url[url.length - 1].includes(".")) url.pop();
            path = url.join("/");
            return path;
        },

        getResources() {
            this.$emit("getResources", false, false, true);
        },
    },
};
</script>